import { Infinity as InfinityIcon, AlertTriangle, Gauge } from 'lucide-react';

/**
 * AiQuotaPill — tiny status badge showing remaining lifetime AI allowance.
 *
 * Props :
 *   quota  : { used, limit, remaining, exceeded, enabled } (from useCreditPacks)
 *   bypass : bool — admin/reviewer, show "illimité"
 *   label  : string — short label shown before the count (e.g. "Sujets IA")
 *   title  : string — optional tooltip override (default = "X/Y utilisés")
 */
export default function AiQuotaPill({ quota, bypass = false, label = 'IA', title }) {
    if (bypass) {
        return (
            <span className="ai-quota-pill ai-quota-pill--bypass" title="Aucun quota (admin)">
                <InfinityIcon size={11} /> {label}
            </span>
        );
    }
    if (!quota || !quota.enabled) return null;

    const ratio = quota.limit > 0 ? quota.used / quota.limit : 0;
    const near = ratio >= 0.8 && !quota.exceeded;
    const cls = quota.exceeded ? 'ai-quota-pill--exceeded'
              : near            ? 'ai-quota-pill--warn'
              :                   'ai-quota-pill--ok';

    const Icon = quota.exceeded || near ? AlertTriangle : Gauge;
    const defaultTitle = `${quota.used}/${quota.limit} utilisés${quota.exceeded ? ' — quota atteint' : ''}`;
    return (
        <span className={`ai-quota-pill ${cls}`} title={title || defaultTitle}>
            <Icon size={11} /> {label} {quota.remaining}/{quota.limit}
        </span>
    );
}
